<template>
  <div class="page events">
    <b-container>
      <b-row>
        <b-col cols="12">
          <div class="panel">
            <k-events-table v-model="selectedEvents"></k-events-table>
          </div>
        </b-col>
      </b-row>
    </b-container>
    <k-button
      variant="primary"
      @click="UjEsemeny"
      size="sm"
      icon="fa-plus"
      class="add-user"
    ></k-button>
  </div>
</template>

<script>
import { ModalFunctions } from '../functions/ModalFunctions';
export default {
  name: 'event-calendar-page',
  data() {
    return {
      selectedEvents: [],
    };
  },
  mounted() {},
  created() {},
  methods: {
    UjEsemeny() {
      ModalFunctions.OpenModal('k-esemeny-kezelo-modal', null);
    },
  },
  computed: {},
  watch: {},
};
</script>
